import http from "./http";

export const fetchCampaignData = () => http.get("/campaigns"); 

export const executeSaveCampaign = (credentials) => {
  return http.post(`/campaigns/add`, credentials) 
}
export const executeUpdateCampaign = (id, payload) => {
  return http.patch(`/campaigns/update/${id}`, payload) 
}

export const executeToggleCampaign = (id) => {
    return http.patch(`/campaigns/${id}/toggle-status`)
}

export const listReferrers = (id) => {
    return http.get(`/campaigns/${id}/referrals`)
}

export const executeUpdateReferralStatus = (referrer,status) => {
    return http.patch(`/campaigns/referrers/${referrer}/status`,{
            reward_status: status
        })
}